export const RANGOS = [
	{
		min: 0,
		nombre: "Hierro",
		color: "#6b7280",
		icono: "🪨"
	},
	{
		min: 200,
		nombre: "Bronce",
		color: "#b45309",
		icono: "🥉"
	},
	{
		min: 500,
		nombre: "Plata",
		color: "#d1d5db",
		icono: "🥈"
	},
	{
		min: 900,
		nombre: "Oro",
		color: "#facc15",
		icono: "🥇"
	},
	{
		min: 1400,
		nombre: "Platino",
		color: "#67e8f9",
		icono: "💠"
	},
	{
		min: 2200,
		nombre: "Diamante",
		color: "#60a5fa",
		icono: "💎"
	},
	{
		min: 3500,
		nombre: "Maestro",
		color: "#c084fc",
		icono: "👑"
	}
];

export const obtenerRango = (xp = 0) => {

	let rangoActual = RANGOS[0];

	for (const rango of RANGOS) {

		if (xp >= rango.min) {
			rangoActual = rango;
		}
	}

	return rangoActual;
};